import { useGetExternalLoyaltyBannersLazy } from '@occc-app/dataAccessLayer/externalLoyalty/queries';
import { AutocompleteProps, FormInputProps, LazyAutocompleteField } from '@occc-app/design-system';
import { BannerConfigurationFragment } from '@occc/graphql';

type ExternalBannersSelectFieldProps = Pick<AutocompleteProps, 'onFocus' | 'onBlur'> & {
  name: string;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
  errorText?: string;
  inputProps?: FormInputProps;
};

export const mapQueryResponseToRawArray = (
  response: ReturnType<typeof useGetExternalLoyaltyBannersLazy>['response'],
) => response.data || [];

export const mapRawResponseItemToAutocompleteOption = (banner: BannerConfigurationFragment) => ({
  value: banner.uuid,
  label: banner.title,
  _raw: banner,
});

export const ExternalBannersSelectField = ({ ...props }: ExternalBannersSelectFieldProps) => {
  return (
    <LazyAutocompleteField<
      BannerConfigurationFragment,
      ReturnType<typeof useGetExternalLoyaltyBannersLazy>['response']
    >
      label='External Source'
      {...props}
      useLazyQuery={useGetExternalLoyaltyBannersLazy}
      mapQueryResponseToRawArray={mapQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawResponseItemToAutocompleteOption}
    />
  );
};
